import { useState } from "react";
import { Modal, Form } from "react-bootstrap";

import styles from "./reasonRejectModalWindow.module.css";

export default function ReasonRejectModalWindow({
  show,
  setShow,
  headerText,
  handleReasonReject,
  handleCloseRejectModal,
  handleRefuse,
  textareaPlaceholder,
}) {
  let [reasonReject, setReasonReject] = useState("");
  const [error, setError] = useState("");
  const [saveKey, setSaveKey] = useState(false);

  const handleChange = (e) => {
    if (e) {
      reasonReject = e.currentTarget.value;
      setReasonReject(reasonReject);
      handleReasonReject(reasonReject);
    }
    if (saveKey) handleErrors();
  };

  const handleErrors = () => {
    if (!reasonReject) {
      setError("Заполните поле");
      return true;
    } else {
      setError("");
      return false;
    }
  };

  const handleClick = (e) => {
    if (e) {
      switch (e.target.id) {
        case "close":
          handleCloseRejectModal();
          break;
        case "reject":
          if (!handleErrors()) {
            handleRefuse();
            setShow(false);
          } else {
            setSaveKey(true);
          }
          break;
        default:
          break;
      }
    }
  };

  return (
    <Modal
      show={show}
      id="close"
      onHide={handleCloseRejectModal}
      aria-labelledby="contained-modal-title-vcenter"
      centered>
      <Modal.Header
        closeButton
        className={styles["form-header"]}>
        <Modal.Title
          className={styles["form-title"]}
          id="contained-modal-title-vcenter">
          {headerText}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className={styles["form-body"]}>
        <Form>
          <Form.Group>
            <textarea
              className={`${styles["form-input"]} ${error ? styles["red-border"] : ""}`}
              rows={3}
              onChange={(e) => {
                handleChange(e);
              }}
              value={reasonReject}
              placeholder={textareaPlaceholder}
            />
            {error && <p className={styles["red-dot"]}>{error}</p>}
          </Form.Group>
        </Form>
      </Modal.Body>

      <Modal.Footer className={styles["form-footer"]}>
        <button
          id="reject"
          className={styles["save-btn"]}
          onClick={(e) => handleClick(e)}>
          {"Подтвердить"}
        </button>
      </Modal.Footer>
    </Modal>
  );
}
